import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { StyledContainer, StyledLabel, StyledNoteRow, StyledRow, StyledValue } from './summary-information-row.styled';

export interface Note {
  label: string;
  value?: React.ReactNode;
}

export interface SummaryInformationRowProps {
  label: string;
  value?: string;
  note?: Note;
  isValueSensitive?: boolean;
}

export const SummaryInformationRow: FunctionComponent<SummaryInformationRowProps> = (props) => {
  const { label, value, note, isValueSensitive, ...rest } = props;

  const renderNote = (noteToRender: Note): React.ReactNode => (
    <StyledNoteRow>
      <StyledLabel component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET}>
        {noteToRender.label}
      </StyledLabel>
      {noteToRender.value}
    </StyledNoteRow>
  );

  return (
    <StyledContainer {...rest}>
      <StyledRow>
        <StyledLabel component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET}>
          {label}
        </StyledLabel>
        {value && (
          <StyledValue
            component="p"
            variant="paragraph2"
            maxBreakpoint={Breakpoint.TABLET}
            data-hj-suppress={isValueSensitive}
          >
            {value}
          </StyledValue>
        )}
      </StyledRow>
      {note && renderNote(note)}
    </StyledContainer>
  );
};
